var React = require('react');

function ArrowRightShort (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"8.91 0 8.2 .69 12.2 4.61 0 4.61 0 5.59 11.99 5.59 8.2 9.31 8.91 10 14 5 8.91 0"}));
}

ArrowRightShort.defaultProps = {"width":"14","height":"10","viewBox":"0 0 14 10"};

module.exports = ArrowRightShort;

ArrowRightShort.default = ArrowRightShort;
